import request from '@/utils/request'

let ActivityApi = {
  
  /*活动列表*/
  activitylist(data, errorback) {
    return request._post('/shop/plus.activity.activity/index', data, errorback);
  },
  /*添加活动*/
  getaddActivity(data, errorback) {
    return request._get('/shop/plus.activity.activity/add', data, errorback);
  },
  addActivity(data, errorback) {
    return request._post('/shop/plus.activity.activity/add', data, errorback);
  },
  /*活动详情*/
  toEditActivity(data, errorback) {
    return request._get('/shop/plus.activity.activity/edit', data, errorback);
  },
  /*编辑活动*/
  editActivity(data, errorback) {
    return request._post('/shop/plus.activity.activity/edit', data, errorback);
  },
  /*删除活动*/
  deleteActivity(data, errorback) {
    return request._post('/shop/plus.activity.activity/delete', data, errorback);
  },
  /*报名记录*/
  LogData(data, errorback) {
    return request._post('/shop/plus.activity.activity/log', data, errorback);
  },
  editLogStatus(data, errorback) {
    return request._post('/shop/plus.activity.activity/checklog', data, errorback);
  },
  /*获取设置*/
  getSetting(data, errorback) {
    return request._get('/shop/plus.activity.activity/setting', data, errorback);
  },
  /*保存设置*/
  setSetting(data, errorback) {
    return request._post('/shop/plus.activity.activity/setting', data, errorback);
  },
}
export default ActivityApi;



// WEBPACK FOOTER //
// ./src/api/activity.js